import { render, staticRenderFns } from "./main-form.vue?vue&type=template&id=2c9aeb76&scoped=true"
import script from "./main-form.vue?vue&type=script&lang=js"
export * from "./main-form.vue?vue&type=script&lang=js"
import style0 from "./main-form.vue?vue&type=style&index=0&id=2c9aeb76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9aeb76",
  null
  
)

export default component.exports